import {makeStyles} from "@material-ui/core";

const styles = makeStyles({
    footer: {
        height: '100px',
    }
});
export const Footer = () => {
    const classes = styles();

    return (
        <footer className={classes.footer}></footer>
    );
}